import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, vShow as _vShow } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = { class: "mt-10 mb-10" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("审批")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("扫描条码")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("团队审核人列表")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("办公场地审批列表")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("驳回")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("通知")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_25 = { class: "dialog-footer" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("驳回")
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { key: 2 }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("关闭")

import { defineComponent, onMounted, reactive, ref, nextTick } from "vue"
import { useStore } from "vuex"
import Api from "@/http/modules/index"
import ScanBarcode from "@/components/ScanBarcode.vue"
import ApprovalTable from "@/components/ApprovalTable.vue"
import Invoice from "@/views/ViewsComponents/paymentPool/Invoice.vue"
import HrApprovalHistory from "@/views/HrApprovalHistory.vue"
import { ElMessage, ElMessageBox } from 'element-plus'
import calculation from '@/utils/calculation'
import tbMix from '@/global_mixin/tableMixin'
import dayjs from 'dayjs'
import { formatNumber, formatTime } from '@/utils/index'
import PaymentModuleUtils from "@/views/typeMapping/PaymentModuleUtils"
interface Itax {
  reimburseIds: any,
  inComeTax: number | undefined,
  taxDifference: number | undefined
}
interface Option {
  desc: string
  disabled: boolean
  id: number | undefined
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { statusFilter, filterType } = PaymentModuleUtils
const { Sub } = calculation
const store = useStore()
const {
  // 获取审批记录
  'POST/approved/conditions': getApprovedConditionsApi,
  //审批列表
  'GET/approved/list': payPoolListApi,
  // 保存审批列表
  'PATCH/approved/approved': payPoolApprovedApi,
  //下拉框选项
  'GET/pay_pool/drop_list': drapListApi,
  //组织审批人列表
  'GET/org_approved/list': orgApprovedListApi,
  //查询支付单据的票据，
  'GET/invoice': invoiceListApi,
  //删除票据
  'DELETE/invoice': deleteInvoiceApi,
  // 保存发票
  'POST/invoice/save': saveInvoiceApi,
  'GET/organizations': organizationsListApi,
  'GET/users/list': userListApi,
  'DELETE/org_approved': orgApprovedDeleteApi,
  'POST/org_approved': addOrgApprovedApi,
  'PATCH/org_approved': orgApprovedChnageApi,
  'POST/lease_approved': addLeaseApprovedApi,
  'PATCH/lease_approved': chgLeaseApprovedApi,
  'DELETE/lease_approved': delLeaseApprovedApi,
  'GET/lease_approved/list': leaseApprovedListApi,
  'GET/house_leases/drop_list': leasesDropListApi,
  // 驳回接口
  'POST/approved/reject': approvedRejectApi,
  // 条形码扫描
  'GET/invoice_expense_vouchers/remind/{id}': remindApi,
  // 企微通知报销人打印面单及发票
  'POST/invoice_expense_vouchers/send_supplement': send_supplementApi,
} = Api

const {
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(getApprovedConditionsApi)

const tableData = ref([])
const tableLoading = ref(false)
const pageSeting = reactive({
  tableRowCount: 0,
  size: 20,
  page: 1
})
const approvalDialogVisiable = ref(false)
const approvalList = ref<Option[]>([])
const approvalData = ref<any>([])
const approvalDataLoading = ref(false)

const ApprovalHistoryRef = ref()

const dropListArr: any = ref([])
const orgApprovedList = ref([])
const approvedListVisible = ref(false)
const approvedListData = ref([])
const invoiceData = ref<any>([])
const currentCoNo = ref("")
const currentCoId = ref("")
const currentCoEstimateAmount = ref(0)

const invoiceTotalAmount = ref(0)
const refInvoice = ref()
const invoiceLoading = ref(false)
const orgApprovedListVisible = ref(false)
const innerOrgVisible = ref(false)
const userList: any = ref([])
const organizationsList: any = ref([])
const orgApprovalByRef = ref()
const InnerComTitle = ref("")
const InnerOrgTitle = ref("")
const comForm = ref({
  companyId: "",
  approvalBy: "",
  customComName: "",
  id: ""
})
const orgForm = ref({
  orgId: "",
  approvalBy: "",
  customOrgName: "",
  id: ""
})
const innerComVisible = ref(false)
const approvalByRef = ref()
userListApi().then((res: any) => userList.value = res)
organizationsListApi().then((res: any) => organizationsList.value = res)
orgApprovedListApi().then((res: any) => orgApprovedList.value = res)
// 场地审批
// 场地审批列表
let leaseList: any = ref([])
let leaseInfo: any = ref({})
let leaseApprovedList: any = ref([])
leasesDropListApi().then((res: any) => leaseList.value = res)
leaseApprovedListApi().then((res: any) => leaseApprovedList.value = res)
const addOrEditApprovalBy = (formEl: any | undefined) => {
  if (!formEl) return
  formEl.validate((valid: any) => {
    if (valid) {
      let { leaseId, approvalBy, id } = leaseInfo.value
      let params = {}
      if (!id) {//增加公司审批人
        let params = {
          approvalBy,
          leaseId
        }
        addLeaseApprovedApi(params).then((res: any) => {
          ElMessage.success("保存成功")
          leaseApprovedList.value.push(res)
          innerComVisible.value = false
        })
      } else {//修改公司审批人
        // console.log('修改')
        let params = {
          leaseId, approvalBy, id
        }
        chgLeaseApprovedApi(params).then((res: any) => {
          ElMessage.success("修改成功")
          innerComVisible.value = false
          leaseInfo.value.id = ""
          let idx = leaseApprovedList.value.findIndex((el: any) => el.id == res.id)
          leaseApprovedList.value.splice(idx, 1, res)
        })
      }

    }
  })
}
const editApprovalBy = (data: any) => {
  InnerComTitle.value = "编辑场地审批"
  let { leaseId, approvalBy, id } = data
  leaseInfo.value = { leaseId, approvalBy, id }
  innerComVisible.value = true
}
const deleteApprovalBy = (data: any) => {
  let { id } = data
  ElMessageBox.confirm("确认删除该场地审批?",
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }
  ).then(() => {
    let formdata: any = new FormData()
    formdata.append('id', id)
    delLeaseApprovedApi(formdata).then((res: any) => {
      let idx = leaseApprovedList.value.findIndex((el: any) => el.id == id)
      leaseApprovedList.value.splice(idx, 1)
    })
  })
}
// 递归处理树形数据
const treeDataFun = (data: Array<any>) => {
  let arr: Array<any> = []
  data.forEach((item: any) => {
    item.label = item.name
    item.value = item.id
    item.children = treeDataFun(item.children)
    arr.push(item)
  })
  return arr;
}
drapListApi().then((res: any) => {
  res.companyCascader = treeDataFun(res.payeeCompanies)
  dropListArr.value = res
}).catch(() => { })

const searchEle = ref()
const queryForm: any = reactive({
  no: "",
  approvedRecordId: "",
  payApproveStatus: "",
  department: "",
  type: "",
  creator: "",
  cashier: "",
  status: [],
  from: "",
  to: "",
  workPlace: '',
})

const searchHandle = () => {
  return fetchData({
    query: {
      ...queryForm,
      createTime: { from: queryForm.from, to: queryForm.to }
    }
  })
}
searchHandle()


const approveObj = reactive({
  reimburseType: 'COST_APPLY',
  company: ''
})
const approvalProcess = () => {
  approvalList.value = []
  approvalDialogVisiable.value = true
  approvalDataLoading.value = true
  approvalData.value = []
  payPoolListApi(approveObj).then((res: any) => {
    res.forEach((el: any) => { el.desc = el.no + ' ' + el.creator })
    approvalList.value = res
    approvalDataLoading.value = false
  }).catch(() => {
    approvalDataLoading.value = false
  })
}
const barCode = (code: string) => {
  let target: Option | undefined = approvalList.value.find((el: any) => el.no == code)
  if (!target) {
    ElMessage.error("列表中不包含该数据，请核对数据")
    return
  }
  approvalData.value.push(target.id)
}
const saveApproval = async () => {
  if (!approvalData.value.length) {
    approvalDialogVisiable.value = false
    return
  }
  let params = {
    "billIds": approvalData.value,
    "userId": store.state.userId
  }
  await payPoolApprovedApi(params)
  ElMessage.success("保存成功")
  approvalDialogVisiable.value = false

  searchHandle()
  // 刷新记录
  ApprovalHistoryRef.value.openApprovalHitory()


}

// 编辑发票
const taxDialogVisible = ref<boolean>(false)
const editTax = (data: any) => {
  taxDialogVisible.value = true
  let { id, no, estimateAmount } = data
  currentCoEstimateAmount.value = estimateAmount
  currentCoNo.value = no
  // console.log(currentCoNo.value)
  currentCoId.value = id
  invoiceData.value = []
  invoiceLoading.value = true
  invoiceListApi({ billId: id }).then((res: any) => {
    invoiceData.value = res.map((el: any) => {
      el.no = no
      el.isEdit = true
      return el
    })
    invoiceLoading.value = false
  }).catch(() => {
    invoiceLoading.value = false
  })


}

const filterMethod = (query: string, item: any) => {
  if (query) {
    return item.no.toString().search(query) != -1
  }
  return item
}
const openApprovedList = (isOrg: boolean) => {
  approvedListVisible.value = !isOrg
  orgApprovedListVisible.value = isOrg
}
const invoiceValues = {
  no: currentCoNo.value, //单号
  invoiceType: "",
  invoiceCode: "",
  invoiceNo: "",
  invoiceDate: "",
  totalAmount: 0,
  taxRate: 0,
  taxAmount: 0,
  taxExcluded: 0,
  inputTaxAmount: 0,
  isEdit: false,
  id: "",
  note: '',
  isManual: 0
}
const addInvoice = (amount?: number) => {
  let rowValue = JSON.parse(JSON.stringify(invoiceValues))
  rowValue.no = currentCoNo.value
  if (amount && amount > 0) {
    rowValue.invoiceType = "NO"
    rowValue.totalAmount = amount
  }
  invoiceData.value.push(rowValue)
}
const deleteInvoice = (data: any) => {
  if (!data.row.id) {
    invoiceData.value.splice(data.$index, 1)
    return
  }
  ElMessageBox.confirm("确认删除已保存票据?", {

    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
  }).then(() => {
    let formdata = new FormData()
    formdata.append("id", data.row.id)
    deleteInvoiceApi(formdata as any).then(() => {
      ElMessage.success("删除成功")
      invoiceData.value.splice(data.$index, 1)
    })
  })
}
const saveInvoice = (data: any) => {
  let { invoiceType, invoiceCode, invoiceNo, invoiceDate, totalAmount, taxRate, taxAmount, taxExcluded, inputTaxAmount, id, note, isManual } = data
  if (!invoiceType) { //判断票据类型是否填写
    ElMessage.warning("请完善票据信息")
    return
  }
  if (invoiceType == 'OR' || invoiceType == "SH_OR" || invoiceType == "SP" || invoiceType == "SH_SP") {//类型为 专票，普票。共用专票/普票 限制
    if (!invoiceNo || !invoiceDate || !totalAmount || totalAmount == 0) { //发票 号码，代码，日期，总金额，需要有
      ElMessage.warning("请完善票据信息")
      return
    }
    if (invoiceType == "SP" || invoiceType == "SH_SP") {
      if (!taxAmount || taxAmount == 0 || !taxExcluded || taxExcluded == 0 || !inputTaxAmount || inputTaxAmount == 0) { //专票或共用专票 税额，进项税额，不含税金额要有
        ElMessage.warning("请完善票据信息")
        return
      }
    }
  }
  if (invoiceType == 'NO' && (!totalAmount || totalAmount == 0)) { // 类型是无票时也判定金额是否为0或者没有
    ElMessage.warning("请完善票据信息")
    return
  }
  if (invoiceType == 'BILL' && !note) { //发票类型为单据时必须要填写备注
    ElMessage.warning("请填写备注信息")
    return
  }
  data.canClick = true
  let res = { id, invoiceType, invoiceCode, invoiceNo, invoiceDate: invoiceDate ? dayjs(invoiceDate).format('YYYY-MM-DD') : '', totalAmount, note, taxRate, taxAmount, taxExcluded, inputTaxAmount, billId: currentCoId.value, isManual }
  // return
  let params = { details: isManual == 1 ? res : "", ...res }

  saveInvoiceApi(params as any).then((res: any) => {
    data.id = res.id
    data.isEdit = true
    data.canClick = false
    ElMessage.success("保存成功")
  }).catch(() => {
    data.canClick = false
  })
}
const totalAmountChange = (data: any) => {
  // 总金额：totalAmount；税率：taxRate
  let { totalAmount, taxRate, isManual, invoiceType } = data
  // 税率非空且税率不为0
  if (!taxRate || taxRate == 0) return;
  // 总金额 -（总金额 / （税率 + 100%））
  let res = Number(totalAmount) - Number(totalAmount) / (1 + Number(taxRate) / 100)
  // 税额四舍五入
  data.taxAmount = Number(res.toFixed(2))
  // 不含税金额
  if (isManual == 0 || isManual === undefined || ['EI_OR', 'EI_SP'].includes(invoiceType)) {
    data.taxExcluded = Number(Number(totalAmount - data.taxAmount).toFixed(2))
  }
  if (data.invoiceType && ['SP', 'SH_SP', 'EI_SP'].includes(data.invoiceType)) {
    data.inputTaxAmount = data.taxAmount
  }
}
const invoiceTypeChange = (data: any) => {
  let { invoiceType } = data
  if (invoiceType != "SP" && invoiceType != "SH_SP") {
    data.inputTaxAmount = 0
  } else {
    data.inputTaxAmount = data.taxAmount
  }
}
const invoiceNoEnterMethod = (invoiceInfo: string) => {
  // 切割单个发票的号码(注意扫码枪输入法中文状态)
  let invoiceInfoArr = invoiceInfo.includes(',') ? invoiceInfo.split(",") : invoiceInfo.split("，")
  // 根据发票号码扫描结果,判断是否已存在
  let isInclude = invoiceData.value.find((_invNo: any) => _invNo.invoiceNo == invoiceInfoArr[3])
  if (isInclude) {
    ElMessage.warning("票据已存在，不能重复添加")
    return
  }
  //解析出来的发票数组长度应该为8
  if (!invoiceInfoArr.length || invoiceInfoArr.length < 7) {
    ElMessage.warning("扫描异常，请重新扫描")
    return;
  }
  let invRow = {
    no: currentCoNo.value,
    isManual: 1,
    invoiceNo: invoiceInfoArr[3],
    invoiceCode: invoiceInfoArr[2],
    totalAmount: 0,
    taxExcluded: Number(invoiceInfoArr[4]),
    invoiceDate: dayjs(invoiceInfoArr[5]).format("YYYY-MM-DD"),
    invoiceType: 'SP',
  }
  if (['10', '04'].includes(invoiceInfoArr[1])) {
    invRow.invoiceType = 'OR'
  }
  // 31,32金额为含税金额
  if (invoiceInfoArr[1] === '31') {
    invRow.invoiceType = 'EI_SP'
    invRow.totalAmount = Number(invoiceInfoArr[4])
    invRow.taxExcluded = 0
  }
  if (invoiceInfoArr[1] === '32') {
    invRow.invoiceType = 'EI_OR'
    invRow.totalAmount = Number(invoiceInfoArr[4])
    invRow.taxExcluded = 0
  }
  invoiceData.value.push(invRow)
}

// 扫描输入
const noData = ref("")
const searchData = () => {
  let _no = noData.value.replace(/[^0-9]/g, '')
  if (!/^\d+$/.test(_no)) {
    ElMessage.warning('序号必须为数字')
    return
  }

  searchEle.value.resetFields()
  queryForm.no = Number(_no)
  queryForm.from = ''
  queryForm.to = ''
  searchHandle().then((res: any) => {
    console.log(res);

    if (MI_tableData.value.length === 0) {
      //没有数据的情况
      ElMessage.warning("未查询到数据")
      return
    }
    editTax(res.data[0])

  }).finally(() => {
    noData.value = ""
  })

}
const getInvoiceTotalAmount = (value: number) => {
  invoiceTotalAmount.value = value
}
const closeInvoiceDialog = async (isConfirm: boolean) => {
  if (isConfirm && Sub(invoiceTotalAmount.value, currentCoEstimateAmount.value) > 0) {
    await ElMessageBox.confirm("请确认是否还有发票需要添加，或添加无票行，当前余额不为0，是否关闭？", {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: "warning"
    })
  }
  taxDialogVisible.value = false
  searchHandle()
}
// 打开发票弹窗，扫描发票二维码的输入框自动聚焦
const invoiceOpen = () => {
  nextTick(() => {
    refInvoice.value.inputFocus()
  })
}
const addApprovalBy = (isOrg: boolean, formEl: any | undefined) => {
  innerComVisible.value = !isOrg
  innerOrgVisible.value = isOrg
  InnerComTitle.value = !isOrg ? "新增场地审批" : ""
  InnerOrgTitle.value = isOrg ? "新增团队审批人" : ""
  // 重置值
  leaseInfo.value = {}
  orgForm.value = {
    orgId: "",
    approvalBy: "",
    customOrgName: "",
    id: ""
  }
  if (!formEl) return
  formEl.resetFields()
}



const addOrEditOrgApprovalBy = (formEl: any | undefined) => {
  if (!formEl) return
  formEl.validate((valid: any) => {
    if (valid) {
      let { orgId, approvalBy, customOrgName, id } = orgForm.value
      if (!id) { //新增组织审批人
        let params = { orgId, approvalBy, customOrgName }
        addOrgApprovedApi(params).then((res: any) => {
          ElMessage.success("保存成功")
          innerOrgVisible.value = false
          orgApprovedList.value.push(res)
          // formEl.resetFields()
        })

      } else {//修改组织审批人
        let params = { orgId, approvalBy, customOrgName, id }
        orgApprovedChnageApi(params).then((res: any) => {
          ElMessage.success("修改成功")
          innerOrgVisible.value = false
          let idx = orgApprovedList.value.findIndex((el: any) => el.id == res.id)
          orgApprovedList.value.splice(idx, 1, res)
          orgForm.value.id = ""
        })
      }
    }
  })
}
const editOrgApprovalBy = (data: any) => {
  InnerOrgTitle.value = "编辑团队审批人"
  let { id, orgId, approvalBy, customOrgName } = data
  orgForm.value.orgId = orgId
  orgForm.value.approvalBy = approvalBy
  orgForm.value.customOrgName = customOrgName
  orgForm.value.id = id
  innerOrgVisible.value = true
}
const deleteOrgApprovalBy = (data: any) => {
  let { id } = data
  ElMessageBox.confirm("确认删除该审批人?",
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }
  ).then(() => {
    let formdata: any = new FormData()
    formdata.append('id', id)
    orgApprovedDeleteApi(formdata).then((res: any) => {
      let idx = orgApprovedList.value.findIndex((el: any) => el.id == id)
      orgApprovedList.value.splice(idx, 1)
    })
  })
}

const rejectFg = ref(false)
const rejectReason = ref('')
let rejectData: any
const showReject = (data: any) => {
  rejectData = data
  rejectReason.value = ''
  rejectFg.value = true
}
const rejectApprove = () => {
  if (rejectReason.value === '') {
    ElMessage.warning('请输入驳回原因')
    return
  }
  const formData: any = new FormData()
  formData.append('billId', rejectData.id)
  formData.append('rejectReason', rejectReason.value)
  approvedRejectApi(formData)
    .then(res => {
      ElMessage.success("驳回成功")
      rejectFg.value = false
      searchHandle()
    })
}

// 通知
const informHandle = (row: { id: number }) => {
  ElMessageBox.confirm('请确认是否发出通知', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
  }).then(() => {
    MI_identify.value = true
    return send_supplementApi({ id: row.id })
  }).finally(() => {
    MI_identify.value = false
    searchHandle()
  })
}


// 扫描条形码
const isShowCode = ref<boolean>(false)
const codeNumber = ref<number | null>()
const codeTable = ref([])
const scanCode = () => {
  codeNumber.value = null
  codeTable.value = []

  isShowCode.value = true
}

const enterCodeHandle = () => {
  remindApi({ id: codeNumber.value }).then((rep) => {
    codeTable.value = rep
  }).finally(() => {
    codeNumber.value = null
  })
}


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_transfer = _resolveComponent("el-transfer")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_tabs, { type: "border-card" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, { label: "HR审批" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_collapse, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_collapse_item, { title: "HR审批-搜索" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form, {
                      ref_key: "searchEle",
                      ref: searchEle,
                      inline: true,
                      model: _unref(queryForm),
                      class: "searchBg",
                      "label-width": "90px",
                      "label-position": "left"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "序号:",
                          prop: "no"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              onKeyup: _cache[0] || (_cache[0] = _withKeys(($event: any) => (searchHandle()), ["enter"])),
                              modelValue: _unref(queryForm).no,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(queryForm).no) = $event)),
                              placeholder: "请输入序号",
                              clearable: "",
                              class: "form-input"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "打包编号:",
                          prop: "approvedRecordId"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _unref(queryForm).approvedRecordId,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(queryForm).approvedRecordId) = $event)),
                              placeholder: "请输入打包编号",
                              clearable: "",
                              class: "form-input"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "审批状态:",
                          prop: "payApproveStatus"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _unref(queryForm).payApproveStatus,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(queryForm).payApproveStatus) = $event)),
                              placeholder: "请选择审批状态",
                              clearable: "",
                              class: "form-input"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_option, {
                                  value: "APPROVE_WAIT",
                                  label: "Hr审核"
                                }),
                                _createVNode(_component_el_option, {
                                  value: "APPROVE_SEC",
                                  label: "财务审核"
                                }),
                                _createVNode(_component_el_option, {
                                  value: "APPROVE_SUCCESS",
                                  label: "审核成功"
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "归属部门:",
                          prop: "department"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _unref(queryForm).department,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(queryForm).department) = $event)),
                              placeholder: "请选择归属部门",
                              clearable: "",
                              class: "form-input"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dropListArr.value.department, (item, idx) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: idx,
                                    label: item,
                                    value: item
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "费用类型:",
                          prop: "type"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _unref(queryForm).type,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(queryForm).type) = $event)),
                              placeholder: "请选择费用类型",
                              clearable: "",
                              class: "form-input"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dropListArr.value.type, (item, idx) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: idx,
                                    label: _unref(filterType)(item),
                                    value: item
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "公司:",
                          prop: "payeeCompanies"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              multiple: true,
                              modelValue: _unref(queryForm).payeeCompanies,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(queryForm).payeeCompanies) = $event)),
                              placeholder: "请选择公司",
                              clearable: "",
                              class: "form-input"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dropListArr.value.payeeCompanies, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    multiple: "",
                                    key: item.id,
                                    value: item.id,
                                    label: item.name
                                  }, null, 8, ["value", "label"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "支付状态:",
                          prop: "status"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              multiple: true,
                              modelValue: _unref(queryForm).status,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(queryForm).status) = $event)),
                              placeholder: "请选择支付状态",
                              clearable: "",
                              class: "form-input"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dropListArr.value.status, (item, idx) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: idx,
                                    value: item,
                                    label: _unref(statusFilter)(item)
                                  }, null, 8, ["value", "label"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "开始时间:",
                          prop: "from"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_date_picker, {
                              class: "form-input",
                              modelValue: _unref(queryForm).from,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(queryForm).from) = $event)),
                              placeholder: "请选择开始时间",
                              "value-format": "YYYY-MM-DD"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "结束时间:",
                          prop: "to"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_date_picker, {
                              class: "form-input",
                              modelValue: _unref(queryForm).to,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(queryForm).to) = $event)),
                              type: "date",
                              placeholder: "请选择结束时间",
                              "value-format": "YYYY-MM-DD"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "单据收集人:",
                          prop: "cashier"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              onKeyup: _cache[10] || (_cache[10] = _withKeys(($event: any) => (searchHandle()), ["enter"])),
                              modelValue: _unref(queryForm).cashier,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(queryForm).cashier) = $event)),
                              placeholder: "请输入单据收集人",
                              clearable: "",
                              class: "form-input"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "发起人:",
                          prop: "creator"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              onKeyup: _cache[12] || (_cache[12] = _withKeys(($event: any) => (searchHandle()), ["enter"])),
                              modelValue: _unref(queryForm).creator,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(queryForm).creator) = $event)),
                              placeholder: "请输入发起人",
                              clearable: "",
                              class: "form-input"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "场地名:",
                          prop: "workPlace"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              onKeyup: _cache[14] || (_cache[14] = _withKeys(($event: any) => (searchHandle()), ["enter"])),
                              modelValue: _unref(queryForm).workPlace,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(queryForm).workPlace) = $event)),
                              placeholder: "请输入场地名",
                              clearable: "",
                              class: "form-input"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _hoisted_1,
                        _createVNode(_component_el_form_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: _cache[16] || (_cache[16] = ($event: any) => (searchHandle()))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_2
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              onClick: _cache[17] || (_cache[17] = ($event: any) => (searchEle.value.resetFields()))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_3
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: approvalProcess
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                onClick: _cache[18] || (_cache[18] = ($event: any) => (scanCode()))
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                onClick: _cache[19] || (_cache[19] = ($event: any) => (openApprovedList(true)))
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                onClick: _cache[20] || (_cache[20] = ($event: any) => (openApprovedList(false)))
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }),
              _createVNode(_component_el_input, {
                onKeyup: _withKeys(searchData, ["enter"]),
                modelValue: noData.value,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((noData).value = $event)),
                placeholder: "扫描序号进行发票管理",
                class: "form-input ml-10",
                clearable: ""
              }, null, 8, ["onKeyup", "modelValue"])
            ]),
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              data: _unref(MI_tableData),
              border: "",
              "max-height": _unref(MI_height) - 70 + 'px'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "序号",
                  prop: "no",
                  fixed: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "发起人",
                  prop: "creator",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "公司",
                  prop: "payeeCompany",
                  width: "150px",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "场地名",
                  prop: "workPlace",
                  width: "150px",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "费用申请部门",
                  prop: "department",
                  width: "150px",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "摘要",
                  prop: "note",
                  width: "180px",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "费用类型",
                  prop: "type",
                  width: "120px"
                }, {
                  default: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(_unref(filterType)(row.type)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "申请费用",
                  prop: "estimateAmount",
                  width: "120px",
                  formatter: _unref(formatNumber),
                  align: "right"
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "支付金额",
                  prop: "amount",
                  width: "110px",
                  formatter: _unref(formatNumber),
                  align: "right"
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "单据收集人",
                  prop: "cashier",
                  width: "150px"
                }),
                _createVNode(_component_el_table_column, {
                  label: "支付状态",
                  prop: "status",
                  width: "120px"
                }, {
                  default: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(_unref(statusFilter)(row.status)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "支付时间",
                  prop: "payAt",
                  width: "110px",
                  formatter: _unref(formatTime),
                  "show-overflow-tooltip": ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "创建时间",
                  prop: "createTime",
                  width: "110px",
                  formatter: _unref(formatTime),
                  "show-overflow-tooltip": ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "审批状态",
                  prop: "approvedStatus",
                  width: "120px"
                }, {
                  default: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(_unref(statusFilter)(row.approvedStatus)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "回退原因",
                  prop: "reason",
                  width: "120px",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "票据状态",
                  prop: "isUploadedInvoice",
                  width: "120px",
                  "show-overflow-tooltip": ""
                }, {
                  default: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(row.isUploadedInvoice === true ? '已上传' : ""), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "驳回原因",
                  prop: "rejectReason",
                  width: "150px",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "操作",
                  fixed: "right",
                  width: "130px"
                }, {
                  default: _withCtx(({ row }) => [
                    (row.status !== 'PAYMENT_REISSUED')
                      ? (_openBlock(), _createBlock(_component_el_space, { key: 0 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_link, {
                              disabled: row.locked === 1 || row.status === 'PAY_FAILED',
                              onClick: ($event: any) => (editTax(row)),
                              type: "primary"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_9
                              ]),
                              _: 2
                            }, 1032, ["disabled", "onClick"]),
                            _createVNode(_component_el_link, {
                              type: "danger",
                              disabled: row.approvedStatus == "TRUN_DOWN" || row.status === "PAY_FAILED",
                              onClick: ($event: any) => (showReject(row))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_10
                              ]),
                              _: 2
                            }, 1032, ["disabled", "onClick"]),
                            (row.dataSource === 'co3' && row.approvedStatus === 'APPROVE_WAIT' && ['COST_REIMBURSE', 'COST_APPLY'].includes(row.type))
                              ? (_openBlock(), _createBlock(_component_el_link, {
                                  key: 0,
                                  onClick: ($event: any) => (informHandle(row))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_11
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data", "max-height"])), [
              [_directive_loading, _unref(MI_identify)]
            ]),
            _createVNode(_component_el_pagination, {
              background: "",
              small: "",
              class: "mt-10",
              total: _unref(MI_total),
              currentPage: _unref(page),
              "onUpdate:currentPage": _cache[22] || (_cache[22] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
              "page-size": _unref(size),
              "onUpdate:page-size": _cache[23] || (_cache[23] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
              "page-sizes": [10, 30, 50, 100, 300],
              layout: "sizes, prev, pager, next, total, jumper",
              onCurrentChange: _unref(MI_pageChange),
              onSizeChange: _unref(MI_sizeChange)
            }, null, 8, ["total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "HR审批记录",
          lazy: ""
        }, {
          default: _withCtx(() => [
            _createVNode(HrApprovalHistory, {
              ref_key: "ApprovalHistoryRef",
              ref: ApprovalHistoryRef
            }, null, 512)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: approvalDialogVisiable.value,
      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((approvalDialogVisiable).value = $event)),
      title: "审批",
      class: "approval-dialog",
      width: "800px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: saveApproval
        }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _unref(approveObj),
          "label-width": "auto",
          inline: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "费用类型：",
              prop: "reimburseType"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(approveObj).reimburseType,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_unref(approveObj).reimburseType) = $event)),
                  onChange: approvalProcess,
                  placeholder: "请选择费用类型"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      value: "COST_REIMBURSE",
                      label: "费用报销"
                    }),
                    _createVNode(_component_el_option, {
                      value: "COST_APPLY",
                      label: "用款申请"
                    }),
                    _createVNode(_component_el_option, {
                      value: "COST_INTERNAL",
                      label: "内部转账"
                    }),
                    _createVNode(_component_el_option, {
                      value: "COST_RENT",
                      label: "房租水电"
                    }),
                    _createVNode(_component_el_option, {
                      value: "COST_SALARY",
                      label: "薪酬发放"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "公司：",
              prop: "company"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(approveObj).company,
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_unref(approveObj).company) = $event)),
                  onChange: approvalProcess,
                  placeholder: "请选择公司",
                  filterable: "",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.getters.sysCompany, (group) => {
                      return (_openBlock(), _createBlock(_component_el_option_group, {
                        label: group.label,
                        key: group.label
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.options, (comp) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: comp.name,
                              value: comp.name,
                              key: comp.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _createVNode(_component_el_divider),
        _createVNode(ScanBarcode, { onBarCode: barCode }),
        _withDirectives(_createVNode(_component_el_transfer, {
          modelValue: approvalData.value,
          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((approvalData).value = $event)),
          props: {
      key: 'id',
      label: 'desc',
    },
          data: approvalList.value,
          "target-order": "push",
          filterable: "",
          "filter-method": filterMethod
        }, null, 8, ["modelValue", "data"]), [
          [_directive_loading, approvalDataLoading.value]
        ]),
        _createVNode(_component_el_divider)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      top: "70px",
      onOpen: invoiceOpen,
      "destroy-on-close": true,
      "close-on-press-escape": false,
      draggable: "",
      "close-on-click-modal": false,
      modelValue: taxDialogVisible.value,
      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((taxDialogVisible).value = $event)),
      title: "编辑发票",
      "show-close": false,
      width: "95%"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[28] || (_cache[28] = ($event: any) => (closeInvoiceDialog(false)))
        }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[29] || (_cache[29] = ($event: any) => (closeInvoiceDialog(true)))
        }, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(Invoice, {
          ref_key: "refInvoice",
          ref: refInvoice,
          invoiceLoading: invoiceLoading.value,
          invoiceTypeList: [
      { label: '普票', value: 'OR' },
      { label: '共用普票', value: 'SH_OR' },
      { label: '专票', value: 'SP' },
      { label: '共用专票', value: 'SH_SP' },
      { label: '无票', value: 'NO' },
      { label: '单据', value: 'BILL' },
      { label: '电子发票-普票', value: 'EI_OR' },
      { label: '电子发票-专票', value: 'EI_SP' },
      { label: '往来', value: 'Intercourse' },
    ],
          onGetInvoiceTotalAmount: getInvoiceTotalAmount,
          currentCoEstimateAmount: currentCoEstimateAmount.value,
          onInvoiceNoEnterMethod: invoiceNoEnterMethod,
          onAddInvoice: addInvoice,
          invoiceData: invoiceData.value,
          onDeleteInvoice: deleteInvoice,
          onSaveInvoice: saveInvoice,
          onTotalAmountChange: totalAmountChange,
          onInvoiceTypeChange: invoiceTypeChange
        }, null, 8, ["invoiceLoading", "currentCoEstimateAmount", "invoiceData"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: approvedListVisible.value,
      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((approvedListVisible).value = $event)),
      class: "approval-dialog",
      title: "办公场地审批列表"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_dialog, {
          modelValue: innerComVisible.value,
          "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((innerComVisible).value = $event)),
          title: InnerComTitle.value,
          "append-to-body": ""
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_el_button, {
              onClick: _cache[33] || (_cache[33] = ($event: any) => (innerComVisible.value = false))
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[34] || (_cache[34] = ($event: any) => (addOrEditApprovalBy(approvalByRef.value)))
            }, {
              default: _withCtx(() => [
                _hoisted_16
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              ref_key: "approvalByRef",
              ref: approvalByRef,
              inline: true,
              model: _unref(leaseInfo),
              class: "demo-form-inline"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "场地",
                  rules: [{ required: true, message: '请选择场地' }],
                  prop: "leaseId"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      filterable: "",
                      modelValue: _unref(leaseInfo).leaseId,
                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_unref(leaseInfo).leaseId) = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(leaseList), (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.alias,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "审核人",
                  rules: [{ required: true, message: '请选择审核人' }],
                  prop: "approvalBy"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      filterable: "",
                      modelValue: _unref(leaseInfo).approvalBy,
                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_unref(leaseInfo).approvalBy) = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userList.value, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.userId,
                            label: item.alias,
                            value: item.userId
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        }, 8, ["modelValue", "title"]),
        _createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          onClick: _cache[36] || (_cache[36] = ($event: any) => (addApprovalBy(false, approvalByRef.value)))
        }, {
          default: _withCtx(() => [
            _hoisted_17
          ]),
          _: 1
        }),
        _createVNode(_component_el_table, { data: _unref(leaseApprovedList) }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "场地名",
              prop: "leaseAlias"
            }),
            _createVNode(_component_el_table_column, {
              label: "用户名",
              prop: "userName"
            }),
            _createVNode(_component_el_table_column, {
              label: "操作",
              prop: "ops"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_space, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      size: "small",
                      onClick: ($event: any) => (editApprovalBy(row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_18
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_el_button, {
                      size: "small",
                      type: "danger",
                      onClick: ($event: any) => (deleteApprovalBy(row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_19
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: orgApprovedListVisible.value,
      "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((orgApprovedListVisible).value = $event)),
      class: "approval-dialog",
      title: "团队审核人列表"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_dialog, {
          modelValue: innerOrgVisible.value,
          "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((innerOrgVisible).value = $event)),
          title: InnerOrgTitle.value,
          "append-to-body": ""
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_el_button, {
              onClick: _cache[41] || (_cache[41] = ($event: any) => (innerOrgVisible.value = false))
            }, {
              default: _withCtx(() => [
                _hoisted_20
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[42] || (_cache[42] = ($event: any) => (addOrEditOrgApprovalBy(orgApprovalByRef.value)))
            }, {
              default: _withCtx(() => [
                _hoisted_21
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              ref_key: "orgApprovalByRef",
              ref: orgApprovalByRef,
              inline: true,
              model: orgForm.value,
              class: "demo-form-inline"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "团队",
                  prop: "orgId",
                  rules: [{ required: true, message: '请选择团队' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      filterable: "",
                      modelValue: orgForm.value.orgId,
                      "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((orgForm.value.orgId) = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organizationsList.value, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.name,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "审核人",
                  prop: "approvalBy",
                  rules: [{ required: true, message: '请选择审核人' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      filterable: "",
                      modelValue: orgForm.value.approvalBy,
                      "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((orgForm.value.approvalBy) = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userList.value, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.userId,
                            label: item.alias,
                            value: item.userId
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "自定义组织名",
                  prop: "customOrgName",
                  rules: []
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: orgForm.value.customOrgName,
                      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((orgForm.value.customOrgName) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        }, 8, ["modelValue", "title"]),
        _createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          onClick: _cache[44] || (_cache[44] = ($event: any) => (addApprovalBy(true, orgApprovalByRef.value)))
        }, {
          default: _withCtx(() => [
            _hoisted_22
          ]),
          _: 1
        }),
        _createVNode(_component_el_table, { data: orgApprovedList.value }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "团队",
              prop: "orgName"
            }),
            _createVNode(_component_el_table_column, {
              label: "自定义组织名",
              prop: "customOrgName"
            }),
            _createVNode(_component_el_table_column, {
              label: "用户名",
              prop: "userName"
            }),
            _createVNode(_component_el_table_column, {
              label: "操作",
              prop: "ops"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_space, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      size: "small",
                      onClick: ($event: any) => (editOrgApprovalBy(row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_23
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_el_button, {
                      size: "small",
                      onClick: ($event: any) => (deleteOrgApprovalBy(row)),
                      type: "danger"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_24
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "驳回原因",
      draggable: "",
      width: "600px",
      modelValue: rejectFg.value,
      "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((rejectFg).value = $event))
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_25, [
          _createVNode(_component_el_button, {
            onClick: _cache[47] || (_cache[47] = ($event: any) => (rejectFg.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_26
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "danger",
            onClick: _cache[48] || (_cache[48] = ($event: any) => (rejectApprove()))
          }, {
            default: _withCtx(() => [
              _hoisted_27
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          placeholder: "请输入驳回原因",
          type: "textarea",
          modelValue: rejectReason.value,
          "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((rejectReason).value = $event)),
          rows: 8
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "条形码扫描",
      modelValue: isShowCode.value,
      "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((isShowCode).value = $event)),
      width: "900px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[51] || (_cache[51] = ($event: any) => (isShowCode.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_31
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          placeholder: "请扫条码后按回车",
          onKeyup: _withKeys(enterCodeHandle, ["enter"]),
          clearable: "",
          modelValue: codeNumber.value,
          "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((codeNumber).value = $event))
        }, null, 8, ["onKeyup", "modelValue"]),
        _createVNode(_component_el_divider),
        _createVNode(_component_el_table, {
          border: "",
          data: codeTable.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "类型",
              prop: "type"
            }, {
              default: _withCtx(({ row }) => [
                (row.type === 'ElectronicInvoice')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_28, "电子发票"))
                  : _createCommentVNode("", true),
                (row.type === 'PaperInvoice')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_29, "纸质发票"))
                  : _createCommentVNode("", true),
                (row.type === 'Other')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_30, "其他文件"))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              align: "right",
              label: "粘贴单数",
              prop: "pasteSingular"
            }),
            _createVNode(_component_el_table_column, {
              align: "right",
              label: "发票张数",
              prop: "invoiceNumber"
            }),
            _createVNode(_component_el_table_column, {
              align: "right",
              formatter: _unref(formatNumber),
              label: "金额",
              prop: "amount"
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              align: "right",
              label: "其中超过1000发票张数",
              prop: "oneThousand",
              width: "200"
            })
          ]),
          _: 1
        }, 8, ["data"]),
        _withDirectives(_createVNode(_component_el_alert, {
          class: "mt-10",
          effect: "dark",
          title: `请检查纸质单据是否有${codeTable.value[1]?.pasteSingular
      }张，并注意金额超过1000的发票有${codeTable.value.reduce((numb, row) => (numb += row.oneThousand), 0)
      }张，其他文件金额为 ${codeTable.value[2]?.amount
      }，请检查是否正确`,
          type: "warning",
          closable: false
        }, null, 8, ["title"]), [
          [_vShow, codeTable.value.length > 0]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})